import React from 'react';
import './badge.scss';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'status' | 'category';
  color?: 'green' | 'blue' | 'grey' | 'red' | 'severity-critical' | 'severity-high' | 'severity-medium' | 'severity-low' | 'severity-neutral';
  size?: 'small' | 'medium';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'category',
  color = 'blue',
  size = 'medium',
  className = '',
}) => {
  const badgeClasses = [
    'finspace-badge',
    `finspace-badge--${variant}`,
    `finspace-badge--${color}`,
    `finspace-badge--${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses}>
      {children}
    </span>
  );
};

export default Badge;
